import { Button } from "@mui/material";
import React from "react";
import SelectModeBanner from "../SelectModeBanner";
import AddIcon from "@mui/icons-material/Add";
import useBasketActions from "../../../Utils/Hooks/useBasketActions";
import { ContractAndRightType } from "../../../Core/Api/Right/right-api-service";
import { useTranslation } from "react-i18next";

export interface ContractBannerProps {
  handleCloseClick: React.MouseEventHandler;
  contracts: ContractAndRightType[];
}

const ContractBanner: React.FC<ContractBannerProps> = (props) => {
  const { t } = useTranslation();
  const { handleCloseClick, contracts } = props;

  const { addContractsToBasket } = useBasketActions();

  const handleAddToBasketClick = () => {
    addContractsToBasket(contracts);
  };

  return (
    <SelectModeBanner
      text={t("banner:contractBanner.body.contractsSelected", { count: contracts.length })}
      onCloseClick={handleCloseClick}
    >
      <Button variant="white" startIcon={<AddIcon />} onClick={handleAddToBasketClick}>
        {t("button:addToOrder")}
      </Button>
    </SelectModeBanner>
  );
};

export default ContractBanner;
